import api from './api';

export const fetchMasterData = async () => {
  const response = await api.get('/master-data/get');
  return response.data;
};

/**
 * Update a flat category (religions, occupations, education)
 */
export const updateMasterCategory = async (category, items) => {
  await api.patch(`/master-data/update/${category}`, { items });
};

/**
 * Update castes for a specific religion
 */
export const updateCastesForReligion = async (religion, castesArray) => {
  await api.put('/master-data/castes', { religion, castes: castesArray });
};

/**
 * Update subcastes for a specific caste
 */
export const updateSubcastesForCaste = async (caste, subcastesArray) => {
  await api.put('/master-data/subcastes', { caste, subcastes: subcastesArray });
};
